import type { ReactNode } from "react";
import type { KitAuthConfig } from "../types";
import { AuthProvider } from "@jetblue/kit-auth-react";
import { KitAuthSession } from "./kit-auth-session";
import { kitAuthClientSetup } from "./setup";

export const KitAuth = ({
  authConfig,
  children,
}: {
  authConfig: KitAuthConfig;
  children: ReactNode;
}) => {
  const client = kitAuthClientSetup(authConfig);
  return (
    <AuthProvider client={client}>
      <KitAuthSession authConfig={authConfig}>{children}</KitAuthSession>
    </AuthProvider>
  );
};
